module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.template_name === 'yykmembership') ? _c('storeDefault', {
    key: "yykmembership"
  }) : (_vm.template_name === 'yykmendian') ? _c('storeSport', {
    key: "yykmendian"
  }) : (_vm.template_name === 'yykuniversal') ? _c('storeUniversal', {
    key: "yykuniversal"
  }) : (_vm.template_name === 'yykweishop') ? _c('mallDefault', {
    key: "yykweishop"
  }) : (_vm.template_name === 'marketingCard') ? _c('marketingCard', {
    key: "marketingCard"
  }) : (_vm.template_name === 'yykcutdown') ? _c('marketingGroup', {
    key: "yykcutdown"
  }) : (_vm.template_name === 'yykcommunity') ? _c('mallCommunity', {
    key: "yykcommunity"
  }) : (_vm.template_name === 'yykcommunitypms') ? _c('communityManagement', {
    key: "yykcommunitypms"
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04846076", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04846076"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/management.vue
// module id = 2434
// module chunks = 0